import { compose } from "recompose";
import { container } from 'op/container';
import { connect } from "react-redux";

export const withPendingStpForms = compose(
    connect(({ stp }) => ({
        stpEditing: stp.editing || [],
    }), (dispatch) => ({
        stpRemoveFromPending: (id) => {
            dispatch(container.resolve('actions').remove_stp_form({ id }));
        },
    })),
);
